





















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptSalesJournal extends Vue {

  public reportTemplate: Common.ReportTemplate = null;
  public deliveryDateFrom: Date = null;
  public deliveryDateTo: Date = null;
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public counterpartCategory: Common.Category = null;
  public categoryGroupCounterpart: Common.CategoryGroup = Common.CategoryGroup.Counterpart;
  public commodity: Common.Commodity = null;
  public commodityCategory: Common.Category = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public onExcelExport :boolean = false;
  public deliveryDateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public deliveryDateToFlag : Common.dateFlags = Common.dateFlags.default;  
  public bookDateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public bookDateToFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){
      var query: Common.SalesJournalReportTemplateQuery = new Common.SalesJournalReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }

    this.bookDateFrom = new Date().getCalendarDate();
    this.bookDateFrom.setDate(1);
    this.bookDateTo = new Date().getCalendarDate();
    this.bookDateTo.setMonth(this.bookDateFrom.getMonth() + 1);
    this.bookDateTo.setDate(0);

    (this.$refs.SalesJournalDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SalesJournalReportQuery = new Common.SalesJournalReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.counterpartCategory = this.counterpartCategory;
    query.commodity = this.commodity;
    query.commodityCategory = this.commodityCategory;
    query.deliveryDateFrom = this.deliveryDateFrom;
    query.deliveryDateTo = this.deliveryDateTo;
    query.bookDateFrom = this.bookDateFrom;
    query.bookDateTo = this.bookDateTo;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
